import { useCallback, useState } from 'react';
import { PaginationProps } from 'antd';
import useCrud from 'hooks/useCrud';
import { list, create, update, del, ListParams } from 'services/api/assistant.group';

const defaultPage: PaginationProps = {
  current: 1,
  pageSize: 10,
  total: 0,
};

function useGroup() {
  const [page, setPage] = useState(defaultPage);

  const crud = useCrud({
    readList: useCallback((params: ListParams) => {
      return list(params).then((res) => {
        const { page: current, pageSize, total, extInfo } = res;

        setPage({
          current,
          pageSize,
          total,
        });

        return extInfo;
      });
    }, []),
    create,
    update,
    del,
  });

  return {
    page,
    setPage,
    ...crud,
  };
}

export default useGroup;
